import { render, staticRenderFns } from "./contactinfo.vue?vue&type=template&id=b8b59f26&scoped=true&"
import script from "./contactinfo.vue?vue&type=script&lang=js&"
export * from "./contactinfo.vue?vue&type=script&lang=js&"
import style0 from "./contactinfo.vue?vue&type=style&index=0&id=b8b59f26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b59f26",
  null
  
)

export default component.exports